import React, { useMemo } from "react";
import { usePage } from "@inertiajs/inertia-react";
import { LabeledInput } from "@/Components/Form";
import { focusAtom } from "jotai-optics";
import { useAtom } from "jotai";
import { DefinitionOfScopes } from "@/Components/DefinitionOfScopes";
import { useSetAtom } from "jotai/index";
import { IconBookMedical } from "@/Icons";
import { FormError } from "@/Components";
import { isEmissionFactorExplorerOpenAtom } from "@/Components/Questions/QuestionBaseForm";

// const inputAtom = focusAtom(createQuestionAtom, (optic) => optic.prop('inputs').at(0));

export function InputTypeCalculateForm({ atom }) {
  const errors = usePage().props?.errors || {};
  const factors = usePage().props?.factors?.data || [];

  const inputAtom = useMemo(
    () => focusAtom(atom, (optic) => optic.prop("inputs").at(0)),
    [atom],
  );

  const setIsEmissionFactorExplorerOpen = useSetAtom(
    isEmissionFactorExplorerOpenAtom,
  );

  const [basePayload] = useAtom(atom);
  const [payload, setPayload] = useAtom(inputAtom);

  const question = usePage().props?.question?.data || {};

  const errorBag = basePayload.errorBag;

  // useEffect(() => {
  //   return () => {
  //     setPayload(RESET);
  //   }
  // }, []);

  const handleFormUpdate = (e) => {
    const { name, value } = e.target;
    setPayload((prev) => ({ ...prev, [name]: value }));
  };

  const factor =
    (payload?.emission_factor_id &&
      factors.find((f) => f.id === payload?.emission_factor_id)) ||
    question?.inputs?.[0]?.emission_factor ||
    null;

  return (
    <div className="flex w-full flex-col items-start">
      {!basePayload?.id && (
        <p className="mb-4">
          Calculate allows you let the reporter report on usage or spendage for
          an activity to calculate emissions. You add an emission factor to
          connect emission to the reported value.
        </p>
      )}

      <div className="w-full">
        <LabeledInput
          name="label"
          title="What's your question?*"
          placeholder="Describe what kind of data you want"
          className="mb-4"
          value={payload?.label || ""}
          onChange={handleFormUpdate}
          error={errors?.[errorBag]?.[`inputs.0.label`]}
        />
      </div>

      <div className="mb-4 w-full">
        <span className="mb-1 block text-[14px]">Emission factor*</span>

        {factor ? (
          <div className="mb-4 block flex min-h-[46px] w-full items-center justify-between border border-borderColor bg-white px-3 py-2 text-gray-700">
            <p>
              <span>{factor.name}</span>

              <span className="ml-2 text-typo-inactive">
                {factor.unit || "-"}
              </span>
            </p>
            <button
              onClick={() => setIsEmissionFactorExplorerOpen(0)}
              className="text-blue underline hover:no-underline"
            >
              Change
            </button>
          </div>
        ) : (
          <button
            onClick={() => setIsEmissionFactorExplorerOpen(0)}
            className="flex min-h-[46px] w-full items-center gap-2 border border-dashed border-gray-darker px-3 py-2 text-blue underline hover:no-underline"
          >
            <IconBookMedical />
            Add emission factor
          </button>
        )}

        <FormError
          error={errors?.[errorBag]?.[`inputs.0.emission_factor_id`]}
        />
      </div>

      {/*<div className="w-full">*/}
      {/*  <LabeledAutocomplete*/}
      {/*    name="emission_factor_id"*/}
      {/*    title="Add emission factor*"*/}
      {/*    options={factorOptions}*/}
      {/*    placeholder="Select the right emission factor"*/}
      {/*    className="mb-4"*/}
      {/*    onSelect={handleFormUpdate}*/}
      {/*    defaultValue={payload?.emission_factor_id}*/}
      {/*    error={*/}
      {/*      errors?.[errorBag] &&*/}
      {/*      errors?.[errorBag]?.[`inputs.0.emission_factor_id`]*/}
      {/*    }*/}
      {/*  />*/}
      {/*</div>*/}

      <DefinitionOfScopes />
    </div>
  );
}
